import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    prop: {
      type: String,
      required: true
    }
  },

  computed: _extends({}, mapState({
    originalJson: function originalJson(state) {
      return state.creative.template.originalJson;
    }
  }), {
    buttonAttrs: function buttonAttrs() {
      return _extends({
        plain: true,
        type: 'text',
        class: 'reset-game-config-button'
      }, this.$attrs);
    },
    currentOriginalConfig: function currentOriginalConfig() {
      return _.get(this.originalJson, 'gameConfig.' + this.prop);
    }
  }),

  methods: {
    handleClick: function handleClick() {
      console.log('原始配置是：', this.currentOriginalConfig);
      this.$emit('change', {
        conf: _.cloneDeep(this.currentOriginalConfig),
        key: this.prop
      });
    }
  }
};